<template>
    <div>
        <UiBreadcrumbs v-editable="blok" :blok="blok" />
    </div>
</template>

<script lang="ts" setup>
import type { IBreadcrumbsConfig } from '@nuxt-monorepo/ui/types';

defineProps<{
    blok: IBreadcrumbsConfig;
}>();
</script>

<style lang="postcss" scoped>
:deep(.breadcrumbs) {
    @apply text-sm text-[#59c2ef];
    .breadcrumbs-item {
        &:not(.current-page):hover {
            @apply underline;
        }
    }

    .iconify {
        @apply h-[20px];
    }

    .breadcrumbs-divider {
        @apply text-[#5a5e6b] text-[10px];
    }

    .current-page {
        @apply text-[#5a5e6b];
    }
}
</style>
